// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-item-list:hover .menu-label{color:#e21e29}", "",{"version":3,"sources":["webpack://./src/views/components/Header/Dropdown/Dropdown.scss"],"names":[],"mappings":"AAAA,kCAAkC,aAAa","sourcesContent":[".menu-item-list:hover .menu-label{color:#e21e29}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
